import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import $ from 'jquery';

class AnswerTypeInput extends React.Component {
  static propTypes = {
    value: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.handler = this.handler.bind(this);
  }

  componentDidMount() {
    $(this.refs.select).dropdown();
  }

  handler(evt) {
    const value = evt.target.value === 'multiple';
    this.props.onChange(value);
  }

  render() {
    const value = this.props.value ? 'multiple' : 'single';

    return (
      <select
        name="choice"
        className="ui dropdown"
        ref="select"
        value={value}
        onChange={this.handler}
      >
        <option value="single">Choix simple</option>
        <option value="multiple">Choix multiple</option>
      </select>
    );
  }
}

export default pure(AnswerTypeInput);



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/questions/AnswerTypeInput.js